import { render } from "./AgeError.vue?vue&type=template&id=9b746c84&scoped=true"
import script from "./AgeError.vue?vue&type=script&lang=js"
export * from "./AgeError.vue?vue&type=script&lang=js"

import "./AgeError.vue?vue&type=style&index=0&id=9b746c84&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b746c84"]])

export default __exports__